/**
 * Control service – kebutuhan control (config remote) dipetakan ke repository.
 */

import * as repo from '../repository.js';

/**
 * Ambil control config dari server (primary + fallback lokal).
 * @returns {Promise<object|null>} Raw JSON control
 */
export async function fetchControl() {
  return repo.fetchControlRaw();
}
